export default {
  passwordErrors(data){
    const errors = []
    if (!data.$dirty) return errors
    !data.minLength && errors.push('Must be valid Password')
    !data.required && errors.push('Password is required.')
    return errors
  },
  emailErrors(data){
    const errors = []
    if (!data.$dirty) return errors
    data.$invalid && errors.push('Must be valid e-mail')
    !data.required && errors.push('E-mail is required')
    return errors
  },
  firstNameErrors(data){
    const errors = []
    if (!data.$dirty) return errors
    data.$invalid && errors.push('Must be valid FirstName')
    !data.required && errors.push('FirstName is required')
    return errors
  },
  lastNameErrors(data){
    const errors = []
    if (!data.$dirty) return errors
    data.$invalid && errors.push('Must be valid LastName')
    !data.required && errors.push('LastName is required')
    return errors
  },
  phoneNumberErrors(data){
    const errors = []
    if (!data.$dirty) return errors
    data.$invalid && errors.push('Must be valid Phone Number')
    !data.required && errors.push('Phone Number is required')
    return errors
  },
  documentDataErrors(data){
    const errors = []
    if (!data.$dirty) return errors
    data.$invalid && errors.push('Must be valid Document Number')
    !data.required && errors.push('Document Number is required')
    return errors
  }
}